import { FC } from 'react';
import { EmptyState, EmptyStateIcons } from '@silverfort/sf-components';
import { useHistory } from 'react-router-dom';

const CustomTemplateEmptyState: FC = () => {
    const history = useHistory();

    const handleCreatePolicyClick = () => {
        history.push('/Policy');
    };

    return (
        <EmptyState
            className="pb-8"
            icon={EmptyStateIcons.NoItems}
            title="No templates here"
            description="When creating a policy, save as a template to find here later."
            actionText="Create a Policy"
            onActionClick={handleCreatePolicyClick}
        />
    );
};

export default CustomTemplateEmptyState;
